/* TL_ATC_MARKER_1786683600 */
/* titanore-board-atc-live 20260814i */
(function(){
  if (document.getElementById('tl-board-buybox-css')) return;
  var s=document.createElement('style');
  s.id='tl-board-buybox-css';
  s.textContent="/* Titanoré board buy-box — matches pan ATC treatment (tl-cta). */\n#tl-board-buybox {\n  width: 100% !important;\n  max-width: 100% !important;\n  align-self: stretch !important;\n  box-sizing: border-box;\n  --tl-ink: #272727;\n  --tl-muted: #555555;\n  --tl-line: #e9e9e9;\n  --tl-accent: #6B1D28;\n  --tl-bg: #fcfaf6;\n  color: var(--tl-ink);\n  font-family: \"DM Sans\", \"Archivo\", system-ui, sans-serif;\n  margin: 0.75rem 0 1.25rem;\n}\n\n#tl-board-buybox .tl-buybox-head {\n  margin: 0 0 1rem;\n}\n\n#tl-board-buybox .tl-size-line {\n  margin: 0 0 0.35rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--tl-muted);\n}\n\n#tl-board-buybox .tl-promise {\n  margin: 0;\n  font-family: \"Instrument Serif\", \"Iowan Old Style\", Georgia, serif;\n  font-size: clamp(1.35rem, 2.4vw, 1.6rem);\n  font-weight: 400;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: var(--tl-ink);\n}\n\n#tl-board-buybox .tl-price {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 0.5rem 0.85rem;\n  margin-bottom: 1.15rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--tl-line);\n}\n\n#tl-board-buybox .tl-price-now {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: clamp(2.2rem, 4vw, 2.7rem);\n  line-height: 1;\n  font-weight: 400;\n}\n\n#tl-board-buybox .tl-price-was {\n  color: var(--tl-muted);\n  text-decoration: line-through;\n  font-size: 1rem;\n}\n\n#tl-board-buybox .tl-price-off {\n  color: var(--tl-accent);\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n/* Match live pan ATC (.tl-shop-cta__btn): #6b1d28, 8px, white label */\n#tl-board-buybox .tl-cta {\n  width: 100%;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 48px;\n  background: #6b1d28;\n  color: #ffffff !important;\n  border: 0;\n  padding: 14px 20px;\n  font: inherit;\n  font-size: 15px;\n  font-weight: 650;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n#tl-board-buybox .tl-cta:hover {\n  opacity: 0.92;\n  background: #6b1d28;\n}\n\n#tl-board-buybox .tl-cta:focus-visible {\n  outline: 2px solid #6b1d28;\n  outline-offset: 3px;\n}\n\n#tl-board-buybox .tl-cta:disabled {\n  opacity: 0.7;\n  cursor: wait;\n}\n\n#tl-board-buybox .tl-trust {\n  margin-top: 0.9rem;\n  text-align: center;\n  font-size: 0.8rem;\n  line-height: 1.4;\n  color: var(--tl-muted);\n}\n\n#tl-board-buybox .tl-trust strong {\n  color: var(--tl-ink);\n  font-weight: 600;\n}\n\n#tl-board-buybox .tl-pay {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem 0.6rem;\n  margin-top: 0.85rem;\n}\n\n#tl-board-buybox .tl-pay img {\n  display: block;\n  height: 22px;\n  width: auto;\n}\n\n#tl-board-buybox .tl-pay-pill {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 2px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  background: #f3f3f3;\n  color: #272727;\n}\n\n/* Hide Selluxe black bag ATC on board PDP when our buybox is present */\nbody.template-suffix-benefit-board-v3:has(#tl-board-buybox) .shop-product-info [class*=\"add-to-cart\"],\nbody.template-suffix-benefit-board-v3:has(#tl-board-buybox) .shop-product-info button[name=\"add\"],\nbody.template-suffix-benefit-board-v3:has(#tl-board-buybox) .shop-product-info .product-form__submit {\n  display: none !important;\n}\n";
  document.head.appendChild(s);
})();
/* king-skill-fix-20260811d — runtime until Liquid storefront cache unfreezes */
/* whybox-moved-under-mix 20260811 */
(function () {
  if (window.__tlKingSkillChefs) return;
  function isChefs() {
    var p = (location.pathname || '').toLowerCase();
    return (
      p.indexOf('/pages/chefs-pan') !== -1 ||
      p.indexOf('/pages/buy-chefs-pan') !== -1 ||
      p.indexOf('/pages/get-chefs-pan') !== -1 ||
      p.indexOf('/pages/shop-chefs-pan') !== -1
    );
  }
  if (!isChefs()) return;
  window.__tlKingSkillChefs = true;

  function lang() {
    var p = (location.pathname || '').toLowerCase();
    return p === '/nl' || p.indexOf('/nl/') === 0 ? 'nl' : 'en';
  }

  function injectCss() {
    if (document.getElementById('tl-king-skill-chefs-css')) return;
    var s = document.createElement('style');
    s.id = 'tl-king-skill-chefs-css';
    s.textContent = [
      '[data-tgem-buy] .tgem-hero__copy{width:min(42rem,88vw)!important;min-width:min(36rem,88vw)!important;max-width:min(42rem,88vw)!important;flex-shrink:0!important}',
      '[data-tgem-buy] .tgem-hero__copy .tgem-lead{display:block!important;width:min(42rem,88vw)!important;min-width:min(20rem,88vw)!important;max-width:min(42rem,88vw)!important;white-space:normal!important;overflow-wrap:break-word!important;word-break:normal!important;writing-mode:horizontal-tb!important}',
      '[data-tgem-buy] .tgem-hero__copy .tgem-eyebrow{font-size:clamp(13px,1.4vw,15px)!important;font-weight:700!important;letter-spacing:.16em!important;color:#fff!important}',
      '[data-tgem-buy] .tgem-hero__copy h1{font-size:clamp(26px,6.2vw,38px)!important;max-width:min(22ch,100%)!important;line-height:1.12!important;overflow-wrap:normal!important;word-break:keep-all!important;hyphens:none!important;-webkit-hyphens:none!important;text-wrap:pretty!important}',
      '[data-tgem-buy] .tgem-hero__copy .tgem-stake{display:none!important}',
      '[data-tgem-buy] .tgem-hero__cta{display:inline-flex!important;align-items:center!important;justify-content:center!important;min-height:48px!important;padding:14px 28px!important;border-radius:2px!important;background:#fff!important;color:#272727!important;border:1px solid #fff!important;font-size:13px!important;font-weight:600!important;letter-spacing:.08em!important;text-transform:uppercase!important;text-decoration:none!important}',
      '@media (min-width:900px){[data-tgem-buy] .tgem-hero__copy h1{font-size:clamp(34px,3.6vw,48px)!important;max-width:18ch!important}}'
    ].join('');
    document.head.appendChild(s);
  }

  function scrubDashes(root) {
    if (!root) return;
    var walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walk.nextNode()) nodes.push(walk.currentNode);
    nodes.forEach(function (n) {
      if (!n.nodeValue || !/[\u2013\u2014]/.test(n.nodeValue)) return;
      if (n.parentElement && n.parentElement.closest('script,style')) return;
      n.nodeValue = n.nodeValue.replace(/[\u2013\u2014]/g, ' - ');
    });
    root.querySelectorAll('[data-en],[data-nl]').forEach(function (el) {
      ['data-en', 'data-nl'].forEach(function (attr) {
        var v = el.getAttribute(attr);
        if (v && /[\u2013\u2014]/.test(v)) el.setAttribute(attr, v.replace(/[\u2013\u2014]/g, ' - '));
      });
    });
  }

  function fixHero() {
    var root = document.querySelector('[data-tgem-buy]');
    if (!root) return;
    var copy = root.querySelector('.tgem-hero__copy') || root.querySelector('.tgem-hero');
    if (!copy) return;
    var eyebrow = copy.querySelector('.tgem-eyebrow');
    if (eyebrow) {
      eyebrow.setAttribute('data-en', 'Titanoré Labs');
      eyebrow.setAttribute('data-nl', 'Titanoré Labs');
      eyebrow.textContent = 'Titanoré Labs';
    }
    var h1 = copy.querySelector('h1') || root.querySelector('h1');
    if (h1) {
      h1.setAttribute('data-en', 'No coating. Nothing to wear off.');
      h1.setAttribute('data-nl', 'Geen coating. Niets dat slijt.');
      h1.setAttribute('data-tgem-h1', '');
      h1.innerHTML = lang() === 'nl' ? 'Geen coating.<br>Niets dat slijt.' : 'No coating.<br>Nothing to wear off.';
    }
    var lead = copy.querySelector('.tgem-lead');
    if (lead) {
      var en = 'Titanium. No coating to wear off. PFAS, PFOA and PTFE-free.';
      var nl = 'Titanium. Geen coating die slijt. PFAS-, PFOA- en PTFE-vrij.';
      lead.setAttribute('data-en', en);
      lead.setAttribute('data-nl', nl);
      lead.textContent = lang() === 'nl' ? nl : en;
    }
    var stake = copy.querySelector('.tgem-stake');
    if (stake) stake.remove();
    /* Hero CTA is Liquid ATC. Do not re-inject "Kies je maat". */
  }

  function fixZeroToxins() {
    document.querySelectorAll('[data-en="Zero Toxins"], .tgem-features span').forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (el.getAttribute('data-en') === 'Zero Toxins' || t === 'Zero Toxins' || t === 'Geen toxines') {
        el.setAttribute('data-en', 'PFAS/PFOA/PTFE-free');
        el.setAttribute('data-nl', 'PFAS/PFOA/PTFE-vrij');
        el.textContent = lang() === 'nl' ? 'PFAS/PFOA/PTFE-vrij' : 'PFAS/PFOA/PTFE-free';
      }
    });
  }

  
  function moveWhyboxUnderMix() {
    var mix = document.querySelector('.tss-mix');
    if (!mix) return;
    // If Liquid already placed a whybox under mix, remove early buybox copy
    var under = document.querySelector('[data-tl-whybox-under-mix], .tgem-whybox.tl-whybox-under-mix');
    var early = document.querySelector('[data-tgem-buy] .tgem-whybox');
    if (under && early && under !== early) {
      early.remove();
      return;
    }
    var why = under || early || document.querySelector('.tgem-whybox');
    if (!why || !mix.parentNode) return;
    // Already after mix?
    if (mix.compareDocumentPosition(why) & Node.DOCUMENT_POSITION_FOLLOWING) {
      // ensure it is the immediate sibling after mix when possible
      if (why.previousElementSibling === mix || why.parentElement === mix.parentElement) {
        why.classList.add('tl-whybox-under-mix');
        why.setAttribute('data-tl-whybox-under-mix', '');
        injectWhyboxCss();
        return;
      }
    }
    mix.parentNode.insertBefore(why, mix.nextSibling);
    why.classList.add('tl-whybox-under-mix');
    why.setAttribute('data-tl-whybox-under-mix', '');
    injectWhyboxCss();
  }

  function injectWhyboxCss() {
    if (document.getElementById('tl-whybox-under-mix-css')) return;
    var s = document.createElement('style');
    s.id = 'tl-whybox-under-mix-css';
    s.textContent = [
      '.tgem-whybox.tl-whybox-under-mix{margin:28px 0 0!important;padding:18px 16px 16px!important;border:1px solid #1c1c1c!important;border-radius:10px!important;background:#fff!important;color:#1c1c1c!important}',
      '.tgem-whybox.tl-whybox-under-mix h2{margin:0 0 12px!important;font-size:16px!important;font-weight:700!important}',
      '.tgem-whybox.tl-whybox-under-mix ul{margin:0!important;padding:0!important;list-style:none!important;display:grid!important;gap:12px!important}',
      '.tgem-whybox.tl-whybox-under-mix li{display:grid!important;grid-template-columns:12px 1fr!important;gap:10px!important;align-items:start!important}',
      '.tgem-whybox.tl-whybox-under-mix li::before{content:""!important;width:7px!important;height:7px!important;margin-top:5px!important;background:#9a7b4f!important;transform:rotate(45deg)!important}',
      '.tgem-whybox.tl-whybox-under-mix strong{display:block!important;font-size:13px!important;font-weight:650!important;color:#1c1c1c!important;line-height:1.3!important}',
      '.tgem-whybox.tl-whybox-under-mix span{display:block!important;margin-top:2px!important;font-size:12px!important;line-height:1.45!important;color:#6b6560!important}',
      '.tgem-whybox.tl-whybox-under-mix .tgem-whybox__cta{display:flex!important;width:100%!important;margin-top:16px!important;min-height:48px!important;align-items:center!important;justify-content:center!important;padding:14px 18px!important;border:0!important;border-radius:8px!important;background:#6b1d28!important;color:#fff!important;font-size:15px!important;font-weight:650!important;text-decoration:none!important}',
      '.tgem-whybox.tl-whybox-under-mix .tgem-whybox__link{display:inline-block!important;margin-top:14px!important;font-size:13px!important;font-weight:550!important;color:#1c1c1c!important;text-decoration:underline!important;text-underline-offset:3px!important}',
      /* hide leftover early whybox if both exist */
      '[data-tgem-buy] .tgem-whybox:not(.tl-whybox-under-mix){display:none!important}'
    ].join('');
    document.head.appendChild(s);
  }

  function demoteSetsAndGuides() {
    var sets = document.querySelector('.section-titanore-sets-spotlight');
    var ugc = document.querySelector('.section-titanore-ugc-carousel');
    var guides = document.querySelector('.section-titanore-guides-strip');
    if (sets && ugc && ugc.parentNode) {
      if (sets.compareDocumentPosition(ugc) & Node.DOCUMENT_POSITION_FOLLOWING) {
        ugc.parentNode.insertBefore(sets, ugc.nextSibling);
      }
    }
    if (guides && guides.parentNode) {
      guides.parentNode.appendChild(guides);
    }
    // Keep whybox as ATC — do not demote to "Kies je maat"
  }

  function run() {
    injectCss();
    fixHero();
    fixZeroToxins();
    scrubDashes(document.querySelector('[data-tgem-buy]'));
    scrubDashes(document.querySelector('.section-titanore-demo-strip'));
    scrubDashes(document.querySelector('.section-titanore-siraat-trustbar'));
    scrubDashes(document.querySelector('.section-titanore-ugc-carousel'));
    demoteSetsAndGuides();
    moveWhyboxUnderMix();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  setTimeout(run, 200);
  setTimeout(run, 800);
  setTimeout(run, 1800);
})();

/* titanore-board-atc-fix 20260814i */
(function(){
  if (window.__tlBoardAtcFix) return; window.__tlBoardAtcFix=1;
  var css = "/* Titanor\u00e9 board buy-box \u2014 matches pan ATC treatment (tl-cta). */\n#tl-board-buybox {\n  width: 100% !important;\n  max-width: 100% !important;\n  align-self: stretch !important;\n  box-sizing: border-box;\n  --tl-ink: #272727;\n  --tl-muted: #555555;\n  --tl-line: #e9e9e9;\n  --tl-accent: #6B1D28;\n  --tl-bg: #fcfaf6;\n  color: var(--tl-ink);\n  font-family: \"DM Sans\", \"Archivo\", system-ui, sans-serif;\n  margin: 0.75rem 0 1.25rem;\n}\n\n#tl-board-buybox .tl-buybox-head {\n  margin: 0 0 1rem;\n}\n\n#tl-board-buybox .tl-size-line {\n  margin: 0 0 0.35rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--tl-muted);\n}\n\n#tl-board-buybox .tl-promise {\n  margin: 0;\n  font-family: \"Instrument Serif\", \"Iowan Old Style\", Georgia, serif;\n  font-size: clamp(1.35rem, 2.4vw, 1.6rem);\n  font-weight: 400;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: var(--tl-ink);\n}\n\n#tl-board-buybox .tl-price {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 0.5rem 0.85rem;\n  margin-bottom: 1.15rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--tl-line);\n}\n\n#tl-board-buybox .tl-price-now {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: clamp(2.2rem, 4vw, 2.7rem);\n  line-height: 1;\n  font-weight: 400;\n}\n\n#tl-board-buybox .tl-price-was {\n  color: var(--tl-muted);\n  text-decoration: line-through;\n  font-size: 1rem;\n}\n\n#tl-board-buybox .tl-price-off {\n  color: var(--tl-accent);\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n#tl-board-buybox .tl-cta {\n  width: 100%;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 52px;\n  background: #6b1d28;\n  color: #ffffff !important;\n  border: 0;\n  padding: 14px 20px;\n  font: inherit;\n  font-size: 15px;\n  font-weight: 650;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s ease, background-color 0.2s ease;\n}\n\n#tl-board-buybox .tl-cta:hover {\n  opacity: 0.92;\n}\n\n#tl-board-buybox .tl-cta:focus-visible {\n  outline: 2px solid #6b1d28;\n  outline-offset: 3px;\n}\n\n#tl-board-buybox .tl-cta:disabled {\n  opacity: 0.7;\n  cursor: wait;\n}\n\n#tl-board-buybox .tl-trust {\n  margin-top: 0.9rem;\n  text-align: center;\n  font-size: 0.8rem;\n  line-height: 1.4;\n  color: var(--tl-muted);\n}\n\n#tl-board-buybox .tl-trust strong {\n  color: var(--tl-ink);\n  font-weight: 600;\n}\n\n#tl-board-buybox .tl-pay {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem 0.6rem;\n  margin-top: 0.85rem;\n}\n\n#tl-board-buybox .tl-pay img {\n  display: block;\n  height: 22px;\n  width: auto;\n}\n\n#tl-board-buybox .tl-pay-pill {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 2px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  background: #f3f3f3;\n  color: #272727;\n}\n\n/* Hide Selluxe black bag ATC on board PDP when our buybox is present */\nbody.template-suffix-benefit-board-v3:has(#tl-board-buybox) .shop-product-info [class*=\"add-to-cart\"],\nbody.template-suffix-benefit-board-v3:has(#tl-board-buybox) .shop-product-info button[name=\"add\"],\nbody.template-suffix-benefit-board-v3:has(#tl-board-buybox) .shop-product-info .product-form__submit {\n  display: none !important;\n}\n";
  var s=document.createElement('style'); s.id='tl-board-buybox-css'; s.textContent=css; document.head.appendChild(s);
})();
/**
 * Titanoré board buy-box — pan-matching ATC.
 * EN: Add to cart · NL: In winkelwagen
 * Self-mounts on board PDP if theme template cache is stale.
 */
(function () {
  var VARIANT_ID = 57831485833603;

  function isBoardPdp() {
    if (document.getElementById('tl-board-buybox')) return true;
    if (document.body && /benefit-board/i.test(document.body.className || '')) return true;
    return /cutting-board|snijplank/i.test(location.pathname || '');
  }

  function currentLang() {
    try {
      if (window.Weglot && typeof Weglot.getCurrentLang === 'function') {
        return Weglot.getCurrentLang();
      }
    } catch (e) {}
    var path = (location.pathname || '').toLowerCase();
    if (path === '/nl' || path.indexOf('/nl/') === 0) return 'nl';
    var m = document.cookie.match(/(?:^|; )wglang=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : 'en';
  }

  function applyI18n(root) {
    var key = currentLang() === 'nl' ? 'nl' : 'en';
    (root || document).querySelectorAll('[data-en][data-nl]').forEach(function (el) {
      var next = el.getAttribute('data-' + key) || el.getAttribute('data-en');
      if (next != null) el.textContent = next;
    });
  }

  function syncStickyLabel() {
    var label = currentLang() === 'nl' ? 'In winkelwagen' : 'Add to cart';
    document.querySelectorAll('.sticky-add-to-cart .button-text').forEach(function (el) {
      el.textContent = label;
    });
    /* Force pan sticky look if old SHOP NOW black style still cached */
    var style = document.getElementById('tl-board-sticky-match');
    if (!style) {
      style = document.createElement('style');
      style.id = 'tl-board-sticky-match';
      style.textContent =
        'body.template-suffix-benefit-board-v3 .sticky-add-to-cart,' +
        'body.template-product.template-suffix-benefit-board-v3 .sticky-add-to-cart{' +
        'background:#1c2b1e!important}' +
        'body.template-suffix-benefit-board-v3 .sticky-add-to-cart button,' +
        'body.template-suffix-benefit-board-v3 .sticky-add-to-cart .button{' +
        'background:#6b1d28!important;color:#ffffff!important;border-radius:8px!important;' +
        'font-size:14px!important;font-weight:700!important;letter-spacing:.04em!important;' +
        'text-transform:none!important;min-height:44px!important}' +
        'body.template-suffix-benefit-board-v3 .shop-product-info button[name="add"],' +
        'body.template-suffix-benefit-board-v3 .shop-product-info .product-form__submit,' +
        'body.template-suffix-benefit-board-v3 .shop-product-info [class*="add-to-cart"]:not(#tl-board-buybox):not(#tl-board-buybox *){' +
        'display:none!important}';
      document.head.appendChild(style);
    }
  }

  function mountBuybox() {
    if (document.getElementById('tl-board-buybox')) return document.getElementById('tl-board-buybox');
    if (!isBoardPdp()) return null;

    var host =
      document.querySelector('.shop-product-info') ||
      document.querySelector('[class*="product-info"]') ||
      document.querySelector('product-info') ||
      document.querySelector('main .product');
    if (!host) return null;

    var box = document.createElement('div');
    box.id = 'tl-board-buybox';
    box.className = 'tl-board-buybox';
    box.setAttribute('data-variant-id', String(VARIANT_ID));
    box.innerHTML =
      '<div class="tl-buybox-head">' +
      '<p class="tl-size-line" data-en="Layered titanium · One board" data-nl="Gelagerd titanium · Één board">Layered titanium · One board</p>' +
      '<p class="tl-promise" data-en="Non-porous. Dishwasher safe. Built for daily prep." data-nl="Niet-poreus. Vaatwasserbestendig. Gemaakt voor dagelijkse prep.">Non-porous. Dishwasher safe. Built for daily prep.</p>' +
      '</div>' +
      '<div class="tl-price" aria-live="polite">' +
      '<span class="tl-price-now">€94</span>' +
      '<span class="tl-price-was">€157</span>' +
      '<span class="tl-price-off" data-en="40% SUMMER DISCOUNT" data-nl="40% ZOMERKORTING">40% SUMMER DISCOUNT</span>' +
      '</div>' +
      '<button type="button" class="tl-cta" data-cta data-en="Add to cart" data-nl="In winkelwagen">Add to cart</button>' +
      '<p class="tl-trust" data-en="Free returns · Juice channel · No PFAS / PFOA / PTFE coating" data-nl="Gratis retour · Sapgoot · Geen PFAS / PFOA / PTFE-coating"><strong>Free returns</strong> · Juice channel · No PFAS / PFOA / PTFE coating</p>';

    var anchor =
      host.querySelector('.price, [class*="product-price"], [class*="Price"]') ||
      host.querySelector('form[action*="/cart/add"]') ||
      host;
    if (anchor && anchor.parentNode) {
      if (anchor.matches('form') || /cart\/add/i.test(anchor.getAttribute('action') || '')) {
        anchor.parentNode.insertBefore(box, anchor);
      } else {
        anchor.parentNode.insertBefore(box, anchor.nextSibling);
      }
    } else {
      host.appendChild(box);
    }
    return box;
  }

  function wire(root) {
    if (!root || root.getAttribute('data-wired') === '1') return;
    root.setAttribute('data-wired', '1');
    var cta = root.querySelector('[data-cta]');
    if (!cta) return;

    function setBusy(busy) {
      cta.disabled = !!busy;
      if (busy) {
        cta.setAttribute('data-prev', cta.textContent || '');
        cta.textContent = currentLang() === 'nl' ? 'Bezig…' : 'Adding…';
      } else {
        var prev = cta.getAttribute('data-prev');
        if (prev) cta.textContent = prev;
        applyI18n(root);
      }
    }

    cta.addEventListener('click', function (e) {
      e.preventDefault();
      if (cta.disabled) return;
      setBusy(true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add_failed');
          window.location.href = '/cart';
        })
        .catch(function () {
          setBusy(false);
          window.location.href = '/products/titanium-cutting-board?variant=' + VARIANT_ID;
        });
    });
  }

  function boot() {
    if (!isBoardPdp()) return;
    var root = document.getElementById('tl-board-buybox') || mountBuybox();
    if (root) {
      applyI18n(root);
      wire(root);
    }
    syncStickyLabel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setTimeout(boot, 600);
  setTimeout(boot, 1600);

  try {
    if (window.Weglot && typeof Weglot.on === 'function') {
      Weglot.on('languageChanged', function () {
        var root = document.getElementById('tl-board-buybox');
        if (root) applyI18n(root);
        syncStickyLabel();
      });
    }
  } catch (e) {}
})();
